import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as _ from 'lodash';

const DEFAULT_CLIENT_RECT = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    height: 0,
    width: 0,
};

export default class extends React.Component<any, any> {
    private node: Element;
    private mounted = false;

    constructor(props) {
        super();
        this.handleWindowResize = _.debounce(this.handleWindowResize.bind(this), 100);
    }

    componentDidMount() {
        this.node = ReactDOM.findDOMNode(this);
        this.mounted = true;
        window.addEventListener('resize', this.handleWindowResize);
        this.forceUpdate();
    }

    handleWindowResize() {
        this.mounted && this.forceUpdate();
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this.handleWindowResize);
    }

    render() {
        const {children} = this.props;
        const rect = (this.node && this.node.getBoundingClientRect()) || DEFAULT_CLIENT_RECT;

        return children(rect);
    }
}



// WEBPACK FOOTER //
// ./resources/modules/utilities/PositionAware.tsx